import { SUBMISSION_STATUS } from '@crazygames/game-types/src/submission/submission-status.type';
import { DOCS_URL } from '../../../../SideMenu/Menu';

export const ALERT_TEXT = 'You have unsaved updated files. Are you sure you want to leave?';
export const NON_RELEASED_STATUSES: SUBMISSION_STATUS[] = [
  'NEW_SUBMISSION',
  'DRAFT',
  'BASIC_LAUNCH_REQUIRES_APPROVAL',
  'REQUIRES_APPROVAL',
  'AWAITING_DEVELOPER_CHANGE',
  'NEW_BUSINESS_REVIEW',
  'UNDER_BUSINESS_REVIEW',
];

export const GAME_GUIDELINES_URL = `${DOCS_URL}/requirements/quality/`;
export const HALF_INPUT_WIDTH = 500;
